import { newProjectStore } from '@/app/features/projects/new-project/new-project.store';
import { projectDetailsStore } from '@/app/features/projects/project-details/project-details.store';
import { projectsListStore } from '@/app/features/projects/projects-list/projects-list.store';
import { projectEventTypeDetailsStore } from '@/app/features/projects/project-event-type-details/project-event-type-details.store';

export const projectsStore = {
  modules: {
    newProjectStore: newProjectStore,
    projectDetailsState: projectDetailsStore,
    projectsListState: projectsListStore,
    projectEventTypeDetailsState: projectEventTypeDetailsStore
  }
};
